import { render, staticRenderFns } from "./FormBankAccount.vue?vue&type=template&id=4b608063&"
import script from "./FormBankAccount.vue?vue&type=script&lang=js&"
export * from "./FormBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports